import { api } from "#/lib/api-client";

import type { ApprovalPageResponse } from "./types";

export const approvalApi = {

  async list(page = 0, size = 10): Promise<ApprovalPageResponse> {

    const { data } = await api.get<ApprovalPageResponse>("/api/hr/leave/applications/inbox", {

      params: { page, size },

    });

    return data;

  },

};